import { getReport } from "crud/reports.crud";
import { REPORTS } from "utils/actionsConsts";
import { REPORT_OUTPUT_FORMAT } from "utils/const";
import { convertByteArrayToBlobUrl } from "utils/converters";

const inferOutputFormatFromFileName = (reportFileName) => {
  const lower = (reportFileName ?? "").toString().toLowerCase();

  if (lower.endsWith(".xlsx")) return REPORT_OUTPUT_FORMAT.EXCELOPENXML;
  if (lower.endsWith(".pdf")) return REPORT_OUTPUT_FORMAT.PDF;

  return REPORT_OUTPUT_FORMAT.PDF;
};

export const getReportAction = (formData, reportFileName) => async (dispatch) => {
  dispatch({
    type: REPORTS.GET_REPORTS_LOADING,
    payload: true,
  });

  const outputFormat = inferOutputFormatFromFileName(reportFileName);

  const payload =
    formData && typeof formData === "object" && !(formData instanceof FormData)
      ? { ...formData }
      : formData;

  if (payload && typeof payload === "object" && !(payload instanceof FormData)) {
    if (payload.parameters !== undefined && payload.parameters !== null && payload.parameters !== "") {
      try {
        const parsedParameters =
          typeof payload.parameters === "string" ? JSON.parse(payload.parameters) : { ...payload.parameters };

        if (parsedParameters && typeof parsedParameters === "object") {
          if (
            parsedParameters.OutputFormat === undefined ||
            parsedParameters.OutputFormat === null ||
            parsedParameters.OutputFormat === ""
          ) {
            parsedParameters.OutputFormat = parsedParameters.outputFormat ?? outputFormat;
          }

          payload.parameters = JSON.stringify(parsedParameters);
        }
      } catch (_e) {
        // If parameters is not valid JSON, do not mutate the payload.
      }
    }
  }

  getReport(payload)
    .then((res) => {
      const link = document.createElement("a");
      link.href = convertByteArrayToBlobUrl(res.data);
      link.setAttribute("download", reportFileName);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch({
        type: REPORTS.GET_REPORTS,
        result: false,
        payload: [],
      });
      dispatch({
        type: REPORTS.GET_REPORTS_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: REPORTS.GET_REPORTS,
        result: false,
        payload: null,
      });
      dispatch({
        type: REPORTS.GET_REPORTS_LOADING,
        payload: false,
      });
      console.log("error", error);
    });
};

export default getReportAction;
